export default __webpack_public_path__ + "static/5-93c3bc25084838b51af9173f8d0f43cb.png";